export default "__VITE_ASSET__ChSe6r_H__"